<template>
  <div>
    <v-container fluid>
      <content-component :datafile="ammonite" />

      <core-footer />
    </v-container>
  </div>
</template>

<script>
import { ammonite } from "@/data/ammonite.js";
import ContentComponent from "../components/ammonite";
import { mdiArrowUp } from "@mdi/js";
import "video.js/dist/video-js.css";

export default {
  name: "Others",
  components: {
    ContentComponent,
    CoreFooter: () => import("@/components/core/Footer"),
  },
  data: () => ({
    ammonite,
    icons: {
      mdiArrowUp,
    },
  }),
};
</script>
<style></style>
